<div *ngIf="InfoTextPermanent" class="lv-infotext-permanent">
  <div class="lv-infotext-permanent-icon">
    <mat-icon [svgIcon]="'SolidInfo'"></mat-icon>
  </div>
  <div [innerHTML]="InfoTextPermanent"></div>
</div>
